import * as types from './types';

const INITIAL_STATE = {
  fetchingMainIncome: false,
  fetchingIncomeBracket: false,
  fetchingUpdate: false,
  fetchingCreate: false,
  mainIncomes: [],
  incomeBrackets: [],
  apiResult: [],
  canCreateNew: false,
};

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case types.INCOMEBRACKET_GET: {
      return {
        ...state,
        incomeBrackets: action.payload.Data,
      };
    }
    case types.INCOMEBRACKET_BEGIN_FETCH:
      return {
        ...state,
        fetchingIncomeBracket: true,
      };
    case types.INCOMEBRACKET_END_FETCH:
      return {
        ...state,
        fetchingIncomeBracket: false,
      };

    case types.INCOMEBRACKET_MAININCOME_GET: {
      return {
        ...state,
        mainIncomes: action.payload.Data,
      };
    }
    case types.INCOMEBRACKET_MAININCOME_BEGIN_FETCH:
      return {
        ...state,
        fetchingMainIncome: true,
      };
    case types.INCOMEBRACKET_MAININCOME_END_FETCH:
      return {
        ...state,
        fetchingMainIncome: false,
      };

    case types.INCOMEBRACKET_CREATE:
      return {
        ...state,
        apiResult: action.payload,
      };
    case types.INCOMEBRACKET_BEGIN_UPDATE_FETCH:
      return {
        ...state,
        fetchingUpdate: true,
      };
    case types.INCOMEBRACKET_END_UPDATE_FETCH:
      return {
        ...state,
        fetchingUpdate: false,
      };

    case types.INCOMEBRACKET_BEGIN_CREATE_FETCH:
      return {
        ...state,
        fetchingCreate: true,
      };
    case types.INCOMEBRACKET_END_CREATE_FETCH:
      return {
        ...state,
        fetchingCreate: false,
      };

    case types.INCOMEBRACKET_POST_CANCREATE:
      return {
        ...state,
        canCreateNew: action.payload.Data,
      };

    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/pages/incomebracket/state/reducer.js